export default "__VITE_ASSET__N2o21TlB__"